import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { HttpService } from '../http.service';
import { DateTime, Duration } from 'luxon';
import { TimeService } from '../time.service';
import * as moment from 'moment';
import { delay } from 'rxjs/operators';




@Component({
  selector: 'app-gantt-dashboard',
  templateUrl: './gantt-dashboard.component.html',
  styleUrls: ['./gantt-dashboard.component.scss']
})
export class GanttDashboardComponent implements OnInit {

  constructor(private http: HttpService, private time: TimeService) { }

  // Canvas related code
  @ViewChild('canvas', { static: false }) canvas: ElementRef<HTMLCanvasElement>;
  // one min = 1 px
  ctx: CanvasRenderingContext2D;
  selectedDate;

  zoomLevel = 1;

  //////////////////////////

  shipmentsColumns = ['sNo', 'est', 'actual', 'status'];
  shipmentsArray = [];

  trailsArray = [];
  date;


  startOfDay = moment().startOf('day').utc().subtract('7' , 'days');
  endOfDay = moment().endOf('day').utc().add('2', 'days');
  dayDifference = this.endOfDay.diff(this.startOfDay, 'days');


  MinutePX = 60;


  BoxHeight = 70;


  CanvasRowHeight = 100;
  BOX_WIDTH = 9;
  lineHeight = [];






  ngOnInit() {
    this.date = new Date();
    this.fetchData(this.startOfDay, this.endOfDay);
    setTimeout(() => {
      this.drawCanvas();
    }, 1000);

  }

  fetchData(start, end) {
    // from=2020-03-19T07:24:11.673Z&to=2020-03-22T07:24:11.673Z
    this.http.get(`timelines?from=${start.toISOString()}&to=${end.toISOString()}&status=CPTD`).subscribe(
      (response: any) => {
        if (response.data.length) {
          this.shipmentsArray = [];
          this.trailsArray = [];
          this.shipmentsArray = response.data.map(e => {
            this.trailsArray.push(e.timeline);
            return {
              sNo: e.shipment.SIN,
              est: this.getHoursandMinutes(e.shipment.estimated.duration),
              actual: '--',
              status: e.shipment.status
            };
          });
        }
      }
    );
  }

  getHoursandMinutes(seconds) {
    const hours = Duration.fromObject( {second : seconds}).toFormat('hh:mm');
    return (hours.split(':')[0] + ' hrs ' + hours.split(':')[1] + ' mins');
  }

  applyFilter(input) {

  }
  redraw() {
    this.fetchData(moment(this.selectedDate).utc(), this.endOfDay);
    this.startOfDay = moment(this.selectedDate).add('1', 'days').startOf('day').utc();
    this.dayDifference = this.endOfDay.diff(this.startOfDay, 'days');

    setTimeout(() => {
      this.drawCanvas(moment(this.selectedDate).startOf('day').utc());
    }, 1000);
  }

  ///////////////////////////// All the new canvas code is here ///////////////////////////
  drawCanvas(startDate = moment().startOf('day').utc().subtract(this.dayDifference - 1 , 'days')) {
    this.canvas.nativeElement.width  = (this.dayDifference * 24) * this.MinutePX;
    this.canvas.nativeElement.height = window.innerHeight;
    this.ctx = this.canvas.nativeElement.getContext('2d');
    this.plotAllHours(this.dayDifference * 24);


    this.plotAllDates(this.startOfDay, this.endOfDay);

    let yAxis = 60;

    for (let i = 0; i < this.trailsArray.length; i++) {
      this.plotBoxesInRow(this.trailsArray[i], this.shipmentsArray[i].sNo, startDate, yAxis);
      yAxis += 80;
    }
  }
  // calculate canvas width using all the dates (Change Later)
  calculateWidthOfCanvas() {
    // this.canvas.nativeElement.width  = 72 * this.MinutePX;
    // this.canvas.nativeElement.height = 100;
    // this.ctx = this.canvas.nativeElement.getContext('2d');
  }
  // plot all the dates
  plotAllDates(day2, day1) {
    let xAxis = 0;
    const yAxis = 14;
    this.ctx.font = this.ctx.font.replace(/\d+px/, '16px');
    let days = 0;
    while (day1.date() !== day2.date()) {
      days++;
      this.ctx.fillText(moment({ ...day2 }).format('DD-MM-YYYY'), xAxis, yAxis);
      day2.add(1, 'day');
      xAxis = (xAxis + 24 * 60) * this.zoomLevel;
    }
    day2.subtract(days, 'day');
  }
  // plot all hours of date
  plotAllHours(hours = 72) {
    let xAxis = 0;
    const yAxis = 40;
    for (let i = 0; i <= hours; i++) {
      const time = i % 24;
      this.ctx.fillText(time + ':00', xAxis, yAxis);
      xAxis = ((i === 0) ? this.MinutePX : ((i + 1) * this.MinutePX)) * this.zoomLevel;
    }
  }

  // plot all the boxes

  plotBoxesInRow(trailData, trailIndex, startDate, yAxis= 60, boxHeight = 60 ) {
    let startOfBox = moment.duration(moment(trailData[0].act_timestamp || trailData[0].est_timestamp).diff(startDate)).asMinutes()
                     * this.zoomLevel;

    let evType = 'est';
    if (trailData[0].act_timestamp) {
      evType = 'act';
    }

    let lastDate = '';
    trailData.forEach((trail, index)  => {
      // calculate boxWidth
      let box = 10;
      if (lastDate !== '') {
        const last = moment.utc(lastDate).local().format().split('+')[0];
        const current = moment.utc(trail.act_timestamp || trail.est_timestamp).local().format().split('+')[0];
        box = this.calculateMinsDifference(this.time.findDiff(last, current)) * this.zoomLevel;
      }

      if (index === 0) {
        this.ctx.save();
        this.ctx.setLineDash([6]);
        this.ctx.strokeRect(startOfBox, yAxis, box, boxHeight);
        startOfBox += 10;
        this.ctx.restore();
      } else {
        this.ctx.rect(startOfBox, yAxis, box, boxHeight);
        this.ctx.stroke();

        if (box > 240) {
          this.ctx.font = this.ctx.font.replace(/\d+px/, '12px');
          // time + label
          this.ctx.fillText(this.formatDate(trail.act_timestamp || trail.est_timestamp), startOfBox + 10, yAxis + 20);
          if (trail.act_timestamp && trail.est_timestamp) {
            this.ctx.save();
            if (this.delayCheck(trail)) {
              this.ctx.fillStyle = 'green';
              this.ctx.fillText('(EARLY)', startOfBox + 90, yAxis + 20);
            } else {
              this.ctx.fillStyle = 'red';
              this.ctx.fillText('(LATE)', startOfBox + 90, yAxis + 20);
            }
            this.ctx.restore();
          }
          // trail
          this.ctx.font = this.ctx.font.replace(/\d+px/, '14px');
          this.ctx.fillText(trail.text, startOfBox + 10, yAxis + 36);
        }
        startOfBox += box;

      }
      lastDate = trail.act_timestamp || trail.est_timestamp;


    });
  }

  delayCheck(trail) {
    const delay = this.time.findDiff(trail.act_timestamp, trail.est_timestamp);
    return (delay.days + delay.hours + delay.minutes) < 0;
  }

  calculateMinsDifference(diff) {
    let mins = Math.abs(diff.days) * 24 * 60;
    mins += Math.abs(diff.hours) * 60;
    mins += Math.abs(diff.minutes);
    return mins;
  }

  changeZoom(val) {
    val ? this.zoomLevel++ : this.zoomLevel--;
    this.clearEntireCanvas();
    this.drawCanvas();

  }

  clearEntireCanvas() {
    this.ctx.clearRect(0, 0, (6 * 24) * this.MinutePX, window.innerHeight);
  }




  // entireBox(trailData, trailIndex) {

  //   const totalBoxWidth = trailData.reduce((a, b) => a + (Math.abs(b.duration) || 10), 0);
  //   // const boxes = trailData.map(box => Math.abs(box.duration || 10));
  //   const boxes = trailData.map(box => Math.abs(box.duration || 10) / (box.duration ? this.BOX_WIDTH : 1));

  //   const boxHeight = (this.CanvasRowHeight * .7) - (this.CanvasRowHeight * .4);

  //   const startDate = new Date();
  //   startDate.setDate(startDate.getDate() - 16);

  //   const diff = this.time.findDiff(startDate.toISOString(), trailData[0].act_timestamp || trailData[0].est_timestamp);
  //   let xDistance = 10;// this.calculateMinsDifference(diff);
  //   this.ctx.font = this.ctx.font.replace(/\d+px/, '10px');


  //   boxes.forEach((box, index)  => {


  //     let fillColor = '#fff';
  //     if (trailData[index].duration < 0) {
  //       fillColor = '#46D11C';
  //     } else if (trailData[index].duration > 0) {
  //       fillColor = '#FF0000';
  //     } else {
  //       fillColor = '#fff';
  //     }
  //     let estTime = '';
  //     let actTime = '';
  //     if (index !== 0) {
  //       estTime = this.formatActEstdTime(trailData[index].est_timestamp);
  //       actTime = this.formatActEstdTime(trailData[index].act_timestamp);
  //     }
  //     this.ctx.fillText(actTime, xDistance, this.lineHeight[trailIndex].actualText);
  //     this.ctx.fillStyle = fillColor;
  //     if (!trailData[index].duration || trailData[index].duration === 0) {
  //       this.ctx.setLineDash([6]);
  //       this.ctx.strokeRect(xDistance, this.lineHeight[trailIndex].boxPlacement, box, boxHeight);
  //     } else {
  //       this.ctx.fillRect(xDistance, this.lineHeight[trailIndex].boxPlacement, box, boxHeight);
  //       this.ctx.fillStyle = '#000';

  //     }
  //     // this.ctx.fillText(box, xDistance, this.lineHeight[trailIndex].boxPlacement + 20);
  //     // this.ctx.fillText(estTime, xDistance, this.lineHeight[trailIndex].estimatedText);

  //     xDistance += box;
  //   });

  // }

  formatActEstdTime(date) {
    if (date) {
      // toShortDateTime
      return DateTime.fromISO(date).toFormat('hh:mm').toLocaleString();
    }
    return '';
  }


  // calculateRowValues(yBuffer = 50) {
  //   this.trailsArray.forEach((e, i) => {
  //     const dimension: any = {};
  //     if (i !== 0) {
  //       yBuffer = 30;
  //     }
  //     dimension.date = ((i * this.CanvasRowHeight) + this.CanvasRowHeight * .0) + yBuffer;
  //     dimension.actualText = ((i * this.CanvasRowHeight) +  this.CanvasRowHeight * .1) + yBuffer;
  //     dimension.boxPlacement = ((i * this.CanvasRowHeight) + this.CanvasRowHeight * .2) + yBuffer;
  //     dimension.estimatedText = ((i * this.CanvasRowHeight) + this.CanvasRowHeight * .7) + yBuffer;
  //     dimension.paddingBottom = ((i * this.CanvasRowHeight) + this.CanvasRowHeight * .8) + yBuffer;
  //     this.lineHeight.push(dimension);
  //   });
  // }

  ///////////////////////////////////////////////////





  formatDate(date) {
    // tslint:disable-next-line: one-variable-per-declaration
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) {
        month = '0' + month;
    }
    if (day.length < 2) {
        day = '0' + day;
    }

    return [day, month, year].join('-');
  }

}
